import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Input, Output } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import * as i1 from '@angular/common/http';
import { takeUntil, map as map$1 } from 'rxjs/operators';
import { Subject } from 'rxjs';
import * as i1$1 from '@ngrx/store';
import { select } from '@ngrx/store';
import { getStepDetails } from 'visa-store';
import { environment } from 'environment-configurations';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'dirty-check-store';
import * as i3 from 'ngx-toastr';
import * as i4 from 'app-services-library';

class APILetterPreview {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getI140Documents(visaType, caseType, caseId, docCategorCode) {
        return this.httpClient.get(`/${visaType}/${caseType}/${caseId}/document/category/${docCategorCode}`).pipe(map((response) => {
            if (response.status === 200 || response.status === 204) {
                return response;
            }
        }));
    }
    getPreview(visaType, caseType, caseId, letterType, superTaskId, taskId, isBackEnabled, payload) {
        const backEnabledFlag = isBackEnabled ? '&isBackEnabled=true' : '';
        return this.httpClient.post(`/${visaType}/${caseType}/${caseId}/letter/${letterType}/preview?superTaskId=${superTaskId}&taskId=${taskId}${backEnabledFlag}`, payload).pipe(map((response) => {
            if (response.status === 200 || response.status === 204) {
                return response;
            }
        }));
    }
    updatePreview(visaType, caseType, caseId, letterType, payload) {
        return this.httpClient.post(`/${visaType}/${caseType}/${caseId}/letter/${letterType}/preview/save`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getI140Preview(superTaskId, caseId, letterType, payload) {
        return this.httpClient.post(`/task/${superTaskId}/case/${caseId}/letter/${letterType}/preview`, payload).pipe(map((response) => {
            if (response.status === 200 || response.status === 204) {
                return response;
            }
        }));
    }
    updateI40Preview(superTaskId, caseId, letterType, payload) {
        return this.httpClient.post(`/task/${superTaskId}/case/${caseId}/letter/${letterType}/preview/save`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
}
APILetterPreview.ɵfac = function APILetterPreview_Factory(t) { return new (t || APILetterPreview)(i0.ɵɵinject(i1.HttpClient)); };
APILetterPreview.ɵprov = i0.ɵɵdefineInjectable({ token: APILetterPreview, factory: APILetterPreview.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(APILetterPreview, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

//import { FroalaEditorOptions } from 'editor-library';
class BaseLetterPreviewLibraryService {
    constructor(store, apiService, toastr, appServicesLibraryService) {
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.appServicesLibraryService = appServicesLibraryService;
        this.observableSubscription$ = new Subject();
        this.redirectionComponent = new EventEmitter();
        this.letterType = sessionStorage.getItem('typeOfLetter');
        this.disabledControls = false;
        this.pdfSrc = null;
        this.editPreview = false;
    }
    loadInit() {
        if (sessionStorage.getItem('wizardTID')) {
            this.loadPreview();
            this.getLastestGeneratedPDF();
        }
        else {
            // Get Specific step details by passing step code
            this.store.pipe(select(getStepDetails, { id: this.inputData.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                this.stepDetails = data;
                this.toggleControlsStatus();
                this.loadPreview();
                this.getLastestGeneratedPDF();
            });
        }
    }
    ngAfterViewInit() {
        this.previewForm.form.valueChanges.pipe(map$1(() => this.previewForm.dirty)).pipe(takeUntil(this.observableSubscription$)).subscribe(dirty => {
            if (dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
    }
    //Toggle controls status based on step status
    toggleControlsStatus() {
        this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
        // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
    }
    getLastestGeneratedPDF() {
        this.apiService.getI140Documents(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, 'DOCTYP')
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response.data.find(x => x.fileCategory.code === this.letterType)) {
                this.isLastestLetterAvailable = response.data.find(x => x.fileCategory.code === this.letterType).fileLocation;
                this.latestLetterGeneratedOn = response.data.find(x => x.fileCategory.code === this.letterType).generatedOn;
            }
        });
    }
    viewDocument() {
        let dataSlice = this.isLastestLetterAvailable.split('/var/imagility/uploads/');
        this.pdfSrc = environment.docs + dataSlice[1];
        window.open(this.pdfSrc, '_blank');
    }
    loadPreview() {
        const isBackEnabled = sessionStorage.getItem('backFromPreview') === 'true';
        if (this.inputData.caseType === 'I140') {
            this.apiService.getI140Preview(this.inputData.superTaskId, this.inputData.caseId, this.letterType, { templateId: sessionStorage.getItem('documentTemplateId') }).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                this.previewLetter = response.data;
            });
        }
        else {
            this.apiService.getPreview(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.letterType, this.inputData.superTaskId, this.inputData.subTaskId, isBackEnabled, { templateId: sessionStorage.getItem('documentTemplateId') }).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                this.previewLetter = response.data;
            });
        }
    }
    editPreviewPDF() {
        if (parseInt(sessionStorage.getItem('documentTemplateId')) === 0) {
            this.redirectionComponent.emit('CreateTemplate');
        }
        else {
            this.editPreview = true;
        }
    }
    generatePDFFile() {
        this.redirectionComponent.emit('LetterPDF');
    }
    savePreviewPDF() {
        let payload = {
            templateContents: this.previewLetter,
            templateId: sessionStorage.getItem('documentTemplateId')
        };
        if (this.inputData.caseType === 'I140') {
            this.apiService.updateI40Preview(this.inputData.superTaskId, this.inputData.caseId, this.letterType, payload).subscribe((response) => {
                if (response) {
                    this.toastr.success(response.message, 'Success');
                    this.previewForm.resetForm(response.data);
                    this.editPreview = false;
                }
            });
        }
        else {
            this.apiService.updatePreview(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.letterType, payload)
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((response) => {
                if (response) {
                    this.toastr.success(response.message, 'Success');
                    this.previewForm.resetForm(response.data);
                    this.editPreview = false;
                    this.previewLetter = response.data;
                }
            });
        }
    }
    backLink() {
        if (parseInt(sessionStorage.getItem('documentTemplateId')) === 0) {
            this.redirectionComponent.emit('CreateTemplate');
        }
        else {
            this.redirectionComponent.emit('LetterTemplate');
        }
        ;
    }
    nextLink() {
        this.redirectionComponent.emit("LetterPDF");
    }
    previewLettereditorValueChange(value) {
        this.previewLetter = value;
    }
    ngOnDestroy() {
        sessionStorage.removeItem('backFromPreview');
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
BaseLetterPreviewLibraryService.ɵfac = function BaseLetterPreviewLibraryService_Factory(t) { return new (t || BaseLetterPreviewLibraryService)(i0.ɵɵinject(i1$1.Store), i0.ɵɵinject(APILetterPreview), i0.ɵɵinject(i3.ToastrService), i0.ɵɵinject(i4.AppServicesLibraryService)); };
BaseLetterPreviewLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: BaseLetterPreviewLibraryService, factory: BaseLetterPreviewLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseLetterPreviewLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.Store }, { type: APILetterPreview }, { type: i3.ToastrService }, { type: i4.AppServicesLibraryService }]; }, { data: [{
            type: Input
        }], redirectionComponent: [{
            type: Output
        }] }); })();

/*
 * Public API Surface of base-letter-preview-library
 */
;

/**
 * Generated bundle index. Do not edit.
 */

export { APILetterPreview, BaseLetterPreviewLibraryService };
//# sourceMappingURL=base-letter-preview-library.js.map
